@switch (entry().kind) {
  @case ('user') {
    <div class="bubble">{{ entry().text }}</div>
  }
  @case ('assistant') {
    <!-- [innerHTML] runs the rendered Markdown through Angular's HTML sanitizer. -->
    <div class="assistant" [innerHTML]="assistantHtml()" (click)="openLinksInNewTab($event)"></div>
  }
  @case ('chart') {
    @if (entry().chart; as chart) {
      <app-agent-chart [chart]="chart" />
    }
  }
  @case ('context') {
    <p class="context-separator">{{ entry().text }}</p>
  }
  @case ('error') {
    <p class="meta error">{{ entry().text }}</p>
  }
  @default {
    <p class="meta">{{ entry().text }}</p>
  }
}
